import { Navigate, Outlet, useParams } from "react-router";
import { isValidLang } from "@/config/routes";
import { useAuth } from "@/contexts/auth-context";
import { getUserRole, type UserRole } from "@/types/auth";

type RoleGuardProps = {
	allowedRoles: UserRole[];
};

export function RoleGuard({ allowedRoles }: RoleGuardProps) {
	const { user } = useAuth();
	const { lang } = useParams<{ lang: string }>();
	const currentLang = lang && isValidLang(lang) ? lang : "pl";
	const role = user ? getUserRole(user) : "end_user";

	if (role !== "admin" && !allowedRoles.includes(role)) {
		return <Navigate to={`/${currentLang}/`} replace />;
	}

	return <Outlet />;
}
